// extracted by mini-css-extract-plugin
export default {"button":"BlackButton_button__XSZL-","small":"BlackButton_small__E-OjE","medium":"BlackButton_medium__buGYF","large":"BlackButton_large__MxRgu"};